/** @jsx jsx */
import { Component } from 'react';
import { jsx, css } from '@emotion/core'
import { default_theme as theme } from '../emotion/theme'

class FormError extends Component {
    render() {

        const { meta } = this.props

        if ( !meta || !meta.error ) {
            return null
        }
        
        return (
            <div css={error}>{meta.error}</div>
        )
    }
}
export default FormError

const error = css`
  color: ${theme.colors.error}
}
`
